import { FC } from "react";

import  TableVacancyCreate  from '../../table/recruiting/tableVacancyCreate'

interface IProps {
  title?: string;
}

const VacancyCreateNewSection: FC<IProps> = () => {
  return (
    <TableVacancyCreate/>
  );
};

export default VacancyCreateNewSection;
